export function StatusBadge({ status }) {
  const map = {
    DRAFT: { cls: "ps-pill ps-pill-neutral", label: "Draft" },
    VALIDATED: { cls: "ps-pill ps-pill-info", label: "Validated" },
    EDI_SENT: { cls: "ps-pill ps-pill-success", label: "EDI Sent" },
    EDI_FAILED: { cls: "ps-pill ps-pill-error", label: "EDI Failed" },
    CANCELLED: { cls: "ps-pill ps-pill-neutral", label: "Cancelled" },
    PENDING: { cls: "ps-pill ps-pill-warning", label: "Pending" },
    SENT: { cls: "ps-pill ps-pill-success", label: "Sent" },
    FAILED: { cls: "ps-pill ps-pill-error", label: "Failed" },
  };
  const item = map[status] || { cls: "ps-pill ps-pill-neutral", label: status };
  return (
    <span className={item.cls} data-testid={`status-badge-${status}`}>
      <span className="dot" />
      {item.label}
    </span>
  );
}

export function GateBadge({ type }) {
  const isIn = type === "IN";
  return (
    <span
      className={`ps-pill ${isIn ? "ps-pill-info" : "ps-pill-warning"}`}
      data-testid={`gate-badge-${type}`}
    >
      <span className="dot" />
      {isIn ? "Gate IN" : "Gate OUT"}
    </span>
  );
}
